import { Service } from "@angular/core";

import { Constants } from "../constants/constants";
import { FormTab, ItemAction } from "../models";

@Service()
export class ActivitiesService {
  public getPermission(activityType: number) {
    switch (activityType) {
      case Constants.ACTIVITY_TYPES_DS3.STRATEGIC_ACTIVITY:
        return Constants.ACTIVITY_PERMISSIONS_DS3.STRATEGIC_ACTIVITY;
      case Constants.ACTIVITY_TYPES_DS3.OPERATIONAL_ACTIVITY:
        return Constants.ACTIVITY_PERMISSIONS_DS3.OPERATIONAL_ACTIVITY;
      case Constants.ACTIVITY_TYPES_DS3.M1_MILESTONE:
        return Constants.ACTIVITY_PERMISSIONS_DS3.M1_MILESTONE;
      default:
        return null;
    }
  }

  public getWorkflowId(activityType: number) {
    switch (activityType) {
      case Constants.ACTIVITY_TYPES_DS3.STRATEGIC_ACTIVITY:
        return Constants.ACTIVITY_WORKFLOW_DS3.STRATEGIC_ACTIVITY;
      case Constants.ACTIVITY_TYPES_DS3.OPERATIONAL_ACTIVITY:
        return Constants.ACTIVITY_WORKFLOW_DS3.OPERATIONAL_ACTIVITY;
      case Constants.ACTIVITY_TYPES_DS3.M1_MILESTONE:
        return Constants.ACTIVITY_WORKFLOW_DS3.M1_MILESTONE;
      default:
        return null;
    }
  }

  public getActivityTypeId(activityType: string) {
    switch (activityType) {
      case "strategic":
        return Constants.ACTIVITY_TYPES_DS3.STRATEGIC_ACTIVITY;
      case "operational":
        return Constants.ACTIVITY_TYPES_DS3.OPERATIONAL_ACTIVITY;
      case "m1":
        return Constants.ACTIVITY_TYPES_DS3.M1_MILESTONE;
      default:
        return null;
    }
  }

  public getActivityPageConfig(activityType: string) {
    switch (activityType) {
      case "strategic":
        return {
          title: "breadcrumbs.activity.strategic_list",
          tableConfig: Constants.MAIN_TABLE_LIST_CONF_KEY.ACTIVITIES_LIST,
          hideDeleteEditRules: [
            {
              propertyName: "editable",
              compareWith: false,
              operator: "equal",
            },
          ] as ItemAction[],
        };
      case "operational":
        return {
          title: "breadcrumbs.activity.operational_list",
          tableConfig: Constants.MAIN_TABLE_LIST_CONF_KEY.ACTIVITIES_LIST,
          hideDeleteEditRules: [
            {
              propertyName: "editable",
              compareWith: false,
              operator: "equal",
            },
          ] as ItemAction[],
        };
      case "m1":
        return {
          title: "national_projects.national_projects_milestone.title",
          tableConfig: Constants.MAIN_TABLE_LIST_CONF_KEY.ACTIVITIES_LIST,
          hideDeleteEditRules: [
            {
              propertyName: "editable",
              compareWith: false,
              operator: "equal",
            },
          ] as ItemAction[],
        };
      default:
        return null;
    }
  }

  public getActivityViewPageConfig(activityType: string) {
    switch (activityType) {
      case "strategic":
        return {
          listTitle: "breadcrumbs.activity.strategic_list",
          title: "breadcrumbs.activity.strategic_view",
        };
      case "operational":
        return {
          listTitle: "breadcrumbs.activity.operational_list",
          title: "breadcrumbs.activity.operational_view",
        };
      case "m1":
        return {
          listTitle: "national_projects.national_projects_milestone.title",
          title: "national_projects.national_projects_milestone.singular_title",
        };
      default:
        return null;
    }
  }

  public getActivityEditPageConfig(activtyType: string, tabsHasError: string[]) {
    const basicTabs: FormTab[] = [
      {
        id: "info",
        title: "common.form.label.information",
        hasError: tabsHasError.includes("info"),
      },
      {
        id: "targets",
        title: "activities.targets",
        hasError: tabsHasError.includes("targets"),
      },
      {
        id: "tasks",
        title: "tasks.tasks",
        hasError: tabsHasError.includes("tasks"),
      },
      {
        id: "team_members",
        title: "national_projects.project_team_members.common_text",
        hasError: tabsHasError.includes("team_members"),
      },
      {
        id: "attachments",
        title: "kpi.attachments",
        hasError: tabsHasError.includes("attachments"),
      },
    ];

    switch (activtyType) {
      case "strategic":
        return {
          title: "breadcrumbs.activity.strategic_edit",
          listTitle: "breadcrumbs.activity.strategic_list",
          tabs: [...basicTabs],
          formValidationKey: Constants.VALIDATORS_CONF_KEY.DS3_STRATEGIC_ACTIVITY_FORM,
        };
      case "operational":
        return {
          title: "breadcrumbs.activity.operational_edit",
          listTitle: "breadcrumbs.activity.operational_list",
          tabs: [...basicTabs],
          formValidationKey: Constants.VALIDATORS_CONF_KEY.DS3_OPERATIONAL_ACTIVITY_FORM,
        };
      case "m1": {
        basicTabs.splice(2, 0, {
          id: "contributing_entities",
          title: "kpi.contributing_entities",
          hasError: tabsHasError.includes("contributing_entities"),
        });

        return {
          title: "national_projects.national_projects_milestone.singular_title",
          listTitle: "national_projects.national_projects_milestone.title",
          tabs: [...basicTabs],
          formValidationKey: Constants.VALIDATORS_CONF_KEY.DS3_PROJECT_MILESTONE_FORM,
        };
      }
      default:
        return null;
    }
  }

  public prepareDataFormSubmit(data: Record<string, unknown>) {
    delete data.sectorsIds;

    if (!data.contributingEntities) data.contributingEntities = [];

    ((data.tasks as Record<string, unknown>[]) || []).forEach((task: Record<string, unknown>) => {
      if (!task.id) {
        delete task.id;
        delete task.fakeId;
      }

      ((task.teamMembers as Record<string, unknown>[]) || []).forEach((teamMember: Record<string, unknown>) => {
        if (!teamMember.id) {
          delete teamMember.id;
          delete teamMember.fakeId;
        }
      });
    });

    ((data.comments as Record<string, unknown>[]) || []).forEach((e: Record<string, unknown>) => {
      if (!e.id) {
        delete e.id;
        delete e.fakeId;
      }
    });

    return data;
  }
}
